import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import useRequest from "../../../hooks/useRequest";
import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import { useSelector } from "react-redux";
import {
  Input, RenderInputFields, SubmitButton, SubInput,
  SubTab
} from "../../Form/Form";

const Add = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    control,
    setValue
  } = useForm();

  const { response, request } = useRequest();
  const { languages } = useSelector((state) => state.setting);
  const history = useHistory();
  const [image, setImage] = useState();
  const [displayImage, setDisplayImage] = useState();

  useEffect(() => {
    document.title = "Add Teams - Calevalab";
  }, []);

  useEffect(() => {
    if (response) {
      toast.success("Teams has been added successfully.");
      history.push("/about-us/teams");
    }
  }, [response]);

  const onSubmit = (data) => {

    const langData = [];
    let fd = new FormData();

    if (data.title) {
      fd.append("title", data.title);
    }

    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;

      if (languages[i].default) {
        fd.append("subTitle", data[`subTitle-${code}`]);
      }
      langData.push({
        languageCode: code,
        subTitle: data[`subTitle-${code}`],
      });
    }

    if (data.image && data.image.length > 0) {
      fd.append("file", data.image[0]);
    }

    fd.append("langData", JSON.stringify(langData));

    request("POST", "about-us-team", fd);
  };

  const handleImage = (event) => {
    event.preventDefault();
    if (event.target.files[0]) {
      setDisplayImage(URL.createObjectURL(event.target.files[0]))
      setError('image', '');
    } else {
      setDisplayImage('');
      setImage('');
      setValue('image', '')
    }
  }

  const handleRemoveImage = () => {
    if (displayImage) {
      setDisplayImage(null);
      setValue("image", null);
    } else {
      setImage(null);
    }
  }
  const InputFields = [
    [
      {
        Component: Input,
        label: "Sub Title",
        type: "text",
        name: "subTitle",
        registerFields: {
          required: true,
        },
      }
    ],
  ];


  const InputFieldsImage = [
    [
      {
        Component: Input,
        label: "Title",
        type: "text",
        name: "title",
        registerFields: {
          required: true,
        },
      },
      {
        Component: Input,
        label: "Image",
        type: "file",
        name: "image",
        registerFields: {
          required: true,
        },
        handleMedia: handleImage,
        handleRemoveMedia: handleRemoveImage,
        isMedia: true,
        accept: "image/*",
        control,
        image,
        displayImage,
        media: "image",
        mediaClass: "image-tab-media",
      },
    ],
  ];
  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Add Teams"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/about-us/teams", name: "Back To Teams" },
        ]}
      />
      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-1"></div>
                <div className="col-xl-10">
                  <h3 className="mb-10 font-weight-bold text-dark">
                    Add New Team
                  </h3>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <RenderInputFields
                      InputFields={InputFieldsImage}
                      errors={errors}
                      register={register}
                    />

                    <div className="row"></div>
                    <div className="card card-custom gutter-b">
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                />
                              ))}
                          </ul>
                        </div>
                      </div>
                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages.length > 0 &&
                            languages.map((lang, index) => (
                              <>
                                <SubInput
                                  key={index}
                                  index={index}
                                  errors={errors}
                                  register={register}
                                  required={true}
                                  InputFields={InputFields}
                                  code={lang.code}
                                />
                              </>
                            ))}
                        </div>
                        <div className="row"></div>
                      </div>
                    </div>
                    <div className="row"></div>

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
